export default __webpack_public_path__ + "0135004fd3577dc1252f7a079a8a3205.svg";